module.exports = __webpack_public_path__ + "img/teacherLogo.a93859b5.png";